<div class="d-flex justify-flex-end">
   <div class="dropdown">
      <button class="dropbtn">
         <i class="fa fa-download"></i> {{ 'general.export_data' | translate }}
      </button>
      <div class="dropdown-content">
         <a (click)="exportToExcel()">{{ 'general.export_as_excel' | translate }} (.xlsx)</a>
         <a (click)="exportToPDF()">{{ 'general.export_as_pdf' | translate }}</a>
         <a (click)="exportToCSV()">{{ 'general.export_as_csv' | translate }}</a>
      </div>
   </div>
</div>
<br>
<main>
   <div *ngIf="
         !(
            this.professorsNumber == 0 &&
            facultyId == '-1' &&
            departmentId == '-1' &&
            name == undefined
         )
      " class="filter-bar">
      <div class="filter-controls">
         <div class="filter-title">
            <h4>{{ 'general.overview' | translate }}</h4>
         </div>
         <div class="filter-right-section">
            <div class="filter-group">
               <label>{{ 'app.filter_by_institution' | translate }}</label>
               <select [(ngModel)]="facultyId" (change)="selectedFaculty()">
                  <option value="-1" selected>
                     {{ 'general.all' | translate }}
                  </option>
                  <ng-container *ngFor="let faculty of this.faculties">
                     <option value="{{ faculty.id }}">
                        {{ faculty.name }}
                     </option>
                  </ng-container>
               </select>
            </div>
            <div class="filter-group">
               <label>{{ 'app.filter_by_department' | translate }}</label>
               <select disabled *ngIf="facultyId == '-1' || facultyId == ''" name="" id="">
                  <option value="">{{ 'general.select_institution_first' | translate }}</option>
               </select>
               <select *ngIf="facultyId !== '-1' && facultyId !== ''" [(ngModel)]="departmentId"
                  (change)="departmentFilter()">
                  <option value="-1" selected>
                     {{ 'general.all' | translate }}
                  </option>
                  <ng-container *ngFor="let department of this.departments">
                     <option value="{{ department.id }}">
                        {{ department.name }}
                     </option>
                  </ng-container>
               </select>
            </div>
            <div class="filter-group">
               <label>{{ 'placeholders.search_by_educator_name' | translate }}</label>
               <div class="search-input-wrapper">
                  <i class="fas fa-search search-icon"></i>
                  <input [(ngModel)]="name" (ngModelChange)="titleFilter()" type="text" name="searchByName" />
               </div>
            </div>
            <div class="filter-group">
               <label>&nbsp;</label>
               <button class="reset-btn" (click)="resetFilter()">
                  <div class="reset-icon-wrapper">
                     <img src="assets/images/icons/refresh.png" alt="Reset" />
                  </div>
               </button>
            </div>
         </div>
      </div>
   </div>
   <div *ngIf="this.professorsNumber != 0" class="scroll white-bg" #contentToCapture>
      <!-- Custom Templates for app-table -->
      <ng-template #statusTemplate let-row>
         <ng-container *ngIf="row.status === 1">
            {{ 'general.active' | translate }}
         </ng-container>
         <ng-container *ngIf="row.status === 0">
            {{ 'general.inactive' | translate }}
         </ng-container>
      </ng-template>

      <!-- <ng-template #editTemplate let-row>
         <i (click)="this.openModal(row.id)" class="far fa-edit editButton" style="cursor: pointer;"></i>
         dsdsd
      </ng-template> -->

      <ng-template #actionsTemplate let-row>
         <div class="action-buttons-group">
            <button class="btn-blue-borderless-md" (click)="openModal(row.id)">
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_733_18913)">
                     <path
                        d="M7.33301 2.66669H2.66634C2.31272 2.66669 1.97358 2.80716 1.72353 3.05721C1.47348 3.30726 1.33301 3.6464 1.33301 4.00002V13.3334C1.33301 13.687 1.47348 14.0261 1.72353 14.2762C1.97358 14.5262 2.31272 14.6667 2.66634 14.6667H11.9997C12.3533 14.6667 12.6924 14.5262 12.9425 14.2762C13.1925 14.0261 13.333 13.687 13.333 13.3334V8.66669"
                        stroke="#004080" stroke-width="1.46087" stroke-linecap="round" stroke-linejoin="round" />
                     <path
                        d="M12.3335 1.66665C12.5987 1.40144 12.9584 1.25244 13.3335 1.25244C13.7086 1.25244 14.0683 1.40144 14.3335 1.66665C14.5987 1.93187 14.7477 2.29158 14.7477 2.66665C14.7477 3.04173 14.5987 3.40144 14.3335 3.66665L8.00016 9.99999L5.3335 10.6667L6.00016 7.99999L12.3335 1.66665Z"
                        stroke="#004080" stroke-width="1.46087" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                     <clipPath id="clip0_733_18913">
                        <rect width="16" height="16" fill="white" />
                     </clipPath>
                  </defs>
               </svg>
               {{ 'general.edit' | translate }}
            </button>
            <button class="btn-blue-borderless-md" (click)="deleteProfessor(row.id)">
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_4338_10847)">
                     <path
                        d="M12.7549 5.76094V13.2433C12.7549 13.4622 12.6651 13.6719 12.5062 13.8219C12.3473 13.9719 12.1309 14.0519 11.9062 14.0519H4.15604C3.93137 14.0519 3.71496 13.9719 3.55606 13.8219C3.39716 13.6719 3.30746 13.4622 3.30746 13.2433V5.76094"
                        stroke="#004080" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                     <path d="M6.91895 11.1855V8.76094" stroke="#004080" stroke-width="1.2" stroke-linecap="round"
                        stroke-linejoin="round" />
                     <path d="M9.14395 11.1855V8.76094" stroke="#004080" stroke-width="1.2" stroke-linecap="round"
                        stroke-linejoin="round" />
                     <path
                        d="M14.1639 4.14062H10.6434M1.99023 4.14062H5.51073M5.51073 4.14062V2.58283C5.51073 2.36388 5.60043 2.15425 5.75933 2.00425C5.91823 1.85425 6.13464 1.77425 6.35931 1.77425H9.70349C9.92816 1.77425 10.1446 1.85425 10.3035 2.00425C10.4624 2.15425 10.5521 2.36388 10.5521 2.58283V4.14063M5.51073 4.14062H10.6434"
                        stroke="#004080" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                     <clipPath id="clip0_4338_10847">
                        <rect width="16" height="16" fill="white" transform="translate(0 0)" />
                     </clipPath>
                  </defs>
               </svg>
               {{ 'app.delete' | translate }}
            </button>

         </div>
      </ng-template>
      <!-- App Table Component -->
      <app-table [columns]="columns" [data]="tableData" [paginatedData]="tableData | paginate: {
            itemsPerPage: 10,
            currentPage: page,
            totalItems: this.professorsNumber
         }" [customTemplates]="{
            statusTemplate: statusTemplate,
            editTemplate: actionsTemplate
         }" [hasCheckboxes]="false">
      </app-table>
   </div>
   <div class="zero-state" *ngIf="
         this.professorsNumber == 0 &&
         facultyId == '-1' &&
         departmentId == '-1' &&
         name == undefined
      ">
      <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
      <h5 class="bold">{{ 'app.there_are_no_educators_registered_in_your_instutition' | translate }}.<br /><span
            class="clickable" routerLink="/administrator/register-module/professor-register">{{ 'general.click_here' |
            translate }}</span> {{ 'app.to_begin_registering_eduacators' | translate }}.</h5>
   </div>
   <div class="zeroState" *ngIf="
         this.professorsNumber == 0 &&
         (name != undefined || facultyId != '-1' || departmentId != '-1')
      ">
      {{ 'new_entries.no_educator_found' | translate }}
   </div>
   <div class="paginationContainer">
      <div></div>
      <pagination-controls *ngIf="this.professorsNumber != 0" class="num" (pageChange)="changePage($event)"
         autoHide="false" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
      <div>
         <button class="btn-blue-filled-md" (click)="registerProfessorModal()">
            <i class="fas fa-plus"></i> {{ 'app.register_educators' | translate }}
         </button>
      </div>

   </div>
</main>